import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchAuditingParameterTableAndFilterSchema, fetchLegendsParameterTableAndFilterSchema } from "model/AuditingParameterModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AuditingParameterContext = createContext();

export const AuditingParameterProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [permissionData, setPermissionData] = useState();
  const [auditingParameterContextData, setAuditingParameterContextData] = useState();
  const [legendsParameterContextData, setLegendsarameterContextData] = useState();


  const fetchAuditingParameterContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:auditingParameter", () =>
        fetchAuditingParameterTableAndFilterSchema([])
      );
      if (response?.success) {
        setAuditingParameterContextData(response?.data);
      }
    } catch (err) {
      setError(err);
      toast.error(err?.message || "Failed to fetch auditing parameter metadata");
    } finally {
      setLoading(false);
    }
  };
  const fetchLegendsContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:legendsParameter", () =>
        fetchLegendsParameterTableAndFilterSchema([])
      );
      if (response?.success) {
        setLegendsarameterContextData(response?.data);
      }
    } catch (err) {
      setError(err);
      toast.error(err?.message || "Failed to fetch auditing parameter metadata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuditingParameterContext.Provider
      value={{
        fetchAuditingParameterContextData,
        fetchLegendsContextData,
        legendsParameterContextData,
        auditingParameterContextData,
        permissionData,
        loading,
        error,
      }}
    >
      {children}
    </AuditingParameterContext.Provider>
  );
};

export const useAuditingParameterContext = () => useContext(AuditingParameterContext);
